<template>
  <div>case</div>
</template>

<script>
export default {
  name: 'case'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";

</style>



// WEBPACK FOOTER //
// src/pages/case/case.vue